import { API_BASE_URL } from "../../config";

async function fetchRankBoxData() {
    try {
      const response = await fetch(`${API_BASE_URL}/rankBoxes`);
      const data = await response.json();
      return {
        permitsPerTenK: data.permitsPerTenK,
        housingStarts12Month: data.housingStarts12Month,
        gdp: data.gdp,
        laborForce: data.laborForce,
        employment: data.employment,
        legalClimate: data.legal_climate,
        tebtr: data.tebtr,
        cnbcBizFriendly: data.cnbc_biz_friendly,
        electricityPrice: data.electricityPrice,
        electricityRank: data.electricityRank
      };
    } catch (error) {
      console.error('Error fetching rank box data:', error);
      return {
        permitsPer10K: null,
        housingStarts12Month: null,
        gdp:null,
        laborForce:null,
        employment:null,
        legalClimate: null,
        tebtr: null,
        cnbcBizFriendly: null,
        electricityPrice: null,
        electricityRank: null
      };
    }
  }

  export const { permitsPerTenK, housingStarts12Month , gdp , laborForce , employment , tebtr , legalClimate , cnbcBizFriendly , electricityPrice , electricityRank } = await fetchRankBoxData();